import React from 'react';
import "./TermsOfServices.css"
import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout";
import DefaultButton from "../../components/Buttons/DefaultButton/DefaultButton";
import apiClient from "../../utils/api";
import {Navigate} from "react-router-dom";
import {ToSContent} from "../TermsOfService/TermsOfService";

function ReviewTermsOfService() {
    const [redirectTo, setRedirectTo] = React.useState(null)
    if (redirectTo) {
        return <Navigate to={redirectTo} />
    }

    const content = <>
        {ToSContent}
        <div className="accept-toc">
            <DefaultButton text="Accept Terms of Service" oneClick={true} onPress={
                async () => {
                    apiClient.acceptToS().then(() => {
                        const profileStr = localStorage.getItem("profile")
                        const profileJson = JSON.parse(profileStr)
                        profileJson.hasAcceptedTos = true
                        localStorage.setItem("profile", JSON.stringify(profileJson))
                        setRedirectTo("/")
                    })
                }
            }
            />
        </div>
    </>

    return <FullWidthLayout
        title="Review Terms of Service"
        mainContent={content}
        />
}

export default ReviewTermsOfService;